import { useEffect } from 'react';

/**
 * スクロール制御用のカスタムフック
 * モーダルやダイアログが開いている時に背景のスクロールを無効にする
 */
export const useScrollLock = (isLocked: boolean) => {
  useEffect(() => {
    if (isLocked) {
      // 現在のスクロール位置を保存
      const scrollY = window.scrollY;

      // body要素にスタイルを適用してスクロールを無効にする
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';

      // クリーンアップ関数
      return () => {
        // スクロールを有効にする
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.width = '';
        document.body.style.top = '';
        
        // 保存していたスクロール位置に戻す
        window.scrollTo(0, scrollY);
      };
    }
  }, [isLocked]);
}; 